import Button from "@/common/components/Button";
import Select from "@/common/components/Select";
import TextField from "@/common/components/TextField";
import { formatCurrency } from "@/common/utils/formatters";
import { useNavigate } from "react-router-dom";
import { CompanyData } from "../../types/company.type";
import { ConsumptionRestriction } from "./ConsumptionRestriction";
import { CreditConfiguration } from "./CreditConfiguration";
import { PeriodRestriction } from "./PeriodRestriction";

interface OperationalInformationSectionProps {
  companyData?: CompanyData;
}

export const OperationalInformationSection = ({
  companyData,
}: OperationalInformationSectionProps) => {
  const navigate = useNavigate();

  if (!companyData) return null;

  const {
    kind,
    granted_credit,
    current_contract: currentContract,
    matrix_branch: matrixBranch,
  } = companyData;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-bold">
          Dados operacionais
        </p>

        <Button
          type="button"
          onClick={() => navigate("/company/mine/contract")}
          operationKlassToCheckPermission="Client::Contracts::Mine"
        >
          Ver contrato
        </Button>
      </div>

      <Select
        label="Serviços"
        placeholder="Não informado"
        value={currentContract?.product_categories?.map(({ id, display_name }) => ({ value: id, label: display_name })) || []}
        isDisabled
      />

      <TextField
        label="Quantidade total de Equipamentos"
        placeholder="Não informado"
        defaultValue={matrixBranch?.equipments_count !== null && matrixBranch?.equipments_count !== undefined ? Number(matrixBranch?.equipments_count) : ''}
        disabled
      />

      <TextField
        label={kind === 'public_company' ? "Cota de empenho" : "Crédito garantido"}
        placeholder="Não informado"
        defaultValue={granted_credit ? formatCurrency(Number(granted_credit)) : ''}
        disabled
      />

      <CreditConfiguration
        productCategoryGrantedCredits={matrixBranch?.product_category_granted_credits}
      />

      {(Number(matrixBranch?.restriction.minimum_kilometers_usage_between_consumptions) > 0 ||
        Number(matrixBranch?.restriction.maximum_kilometers_usage_between_consumptions) > 0 ||
        Number(matrixBranch?.restriction.minimum_seconds_interval_between_consumptions) > 0 ||
        Number(matrixBranch?.restriction.minimum_seconds_usage_between_consumptions) > 0) && (
          <ConsumptionRestriction restriction={matrixBranch?.restriction} />
        )}

      <PeriodRestriction
        periodRestrictions={matrixBranch?.restriction?.period_restrictions}
      />
    </div>
  );
};
